
















import Vue from 'vue';
import {Component, Prop, Watch} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import defaultPayTag from '@/constants/defaultPayTag';
import defaultIncomeTag from '@/constants/defaultIncomeTag';

@Component({
  components: {Icon},
})
export default class Tags extends Vue {
  @Prop() value!: myTag;
  @Prop(String) recordType!: string;
  iconName = this.value.iconName;
  defaultIconName = '';
  totalTagList: myTag[] = [];

  get tagList() {
    return this.$store.state.tagList as myTag[];
  }

  @Watch('recordType')
  onRecordTypeChanged() {
    this.getCurrentTagList(this.recordType);
  }

  created() {
    this.$store.commit('initTag');
    this.getCurrentTagList(this.recordType);
  }

  getCurrentTagList(type: string) {
    if (type === '-') {
      this.totalTagList = this.tagList.filter(item => item.type === '-');
      this.defaultIconName = defaultPayTag.iconName;
    } else if (type === '+') {
      this.totalTagList = this.tagList.filter(item => item.type === '+');
      this.defaultIconName = defaultIncomeTag.iconName;
    }
    return;
  }

  manageTags() {
    this.$router.push({path: '/tagsmanage/'});
  }

  selectIcon(icon: myTag) {
    this.iconName = icon.iconName;
    this.$emit('update:value', icon);
    return;
  }

}
